import {Search} from '../../../content/forms'
import React, {Dispatch, memo, SetStateAction, useState} from 'react'
import {Headers, SortKeys, SortOrder} from '../types'
import {
    usePaginatedData,
    usePeriod,
    useSearchedData,
    useSortedData,
    useTicketsDataTable,
} from '../../../../../app/features'
import {DateRangeType, LoadingState} from '../../../../../global'
import {DATE_RANGE} from '../../../../../app/@components'
import {THead} from '../components/THead'
import {Pagination} from '../../../content/pagination/Pagination'
import {SAVTransformedTicket} from '../../../../../app/@types'
import {TicketRow} from '../../../../../app/pages/sav'
import {DEFAULT_DATE_RANGE} from '../../../../../app/@types/global'

const DEFAULT_SORT_KEY = 'created_at'
const DEFAULT_SORT_ORDER = 'desc'

const headers: Headers<SAVTransformedTicket>[] = [
    {key: 'created_at', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'subject', label: 'Sujet', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'product', label: 'Services', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'assign', label: 'Détails', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'description', label: 'Description', className: 'fw-bolder text-muted bg-light'},
    {key: 'satisfaction', label: 'satisfaction', className: 'fw-bolder text-muted bg-light'},
    {key: 'status', label: 'Status', className: 'fw-bolder text-muted bg-light min-w-200px'},
]

const SearchBar = memo(({setSearchQuery}: {setSearchQuery: Dispatch<SetStateAction<string>>}) => (
    <div className="col-12 col-sm-6 col-md-4">
        <Search setSearchInput={setSearchQuery} />
    </div>
))

const DateRangeSelector = memo(({
                                    onDateRangeChange,
                                    loading,
                                    setLoading,
                                }: {
    onDateRangeChange: (range: DateRangeType) => void
    loading: LoadingState
    setLoading: (state: LoadingState) => void
}) => (
    <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-end align-items-end">
        <DATE_RANGE onDateRangeChange={onDateRangeChange} loading={loading} setLoading={setLoading} />
    </div>
))


const TablesWidget26 = () => {

    const [selectedDateRange, setSelectedDateRange] = useState<DateRangeType>(DEFAULT_DATE_RANGE)
    const period = usePeriod(selectedDateRange)
    const [sortKey, setSortKey] = useState<SortKeys<SAVTransformedTicket>>(DEFAULT_SORT_KEY)
    const [sortOrder, setSortOrder] = useState<SortOrder>(DEFAULT_SORT_ORDER)
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [loading, setLoading] = useState<LoadingState>('idle')
    const {data,} = useTicketsDataTable({period, setLoading})

    const dataSorted: SAVTransformedTicket[] = useSortedData({
        data, sortKey, reverse: sortOrder === 'desc',
    })
    const {searchedData, setSearchQuery} = useSearchedData<SAVTransformedTicket>({
        data: dataSorted,
    })
    const paginatedData = usePaginatedData<SAVTransformedTicket>({
        currentPage, itemsPerPage, data: searchedData,
    })

    const handleDateRangeChange = (dateRange: DateRangeType) => {
        setSelectedDateRange(dateRange)
    }

    return (
        <>
            <div className="row d-flex justify-content-between my-7">
                <SearchBar setSearchQuery={setSearchQuery} />
                <DateRangeSelector
                    onDateRangeChange={handleDateRangeChange}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>

            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">

                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                           children={<th />}
                    />

                    <tbody>
                    {
                        paginatedData.map((ticket, index) => (
                            <TicketRow ticket={ticket} index={index} key={index} />
                        ))
                    }
                    </tbody>

                </table>
            </div>

            <Pagination itemsPerPage={itemsPerPage}
                        totalItems={data.length}
                        setCurrentPage={setCurrentPage}
                        setItemsPerPage={setItemsPerPage}
            />
        </>
    )
}

export {TablesWidget26}